"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgListUl(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M2.021 16.126a2.021 2.021 0 110 4.043 2.021 2.021 0 010-4.043zm21.221 1.263a.758.758 0 01.103 1.51l-.103.006H8.084a.758.758 0 01-.103-1.509l.103-.007h15.158zm-21.22-7.326a2.021 2.021 0 11-.002 4.043 2.021 2.021 0 01.001-4.043zm21.22 1.263a.758.758 0 01.103 1.51l-.103.006H8.084a.758.758 0 01-.103-1.509l.103-.007h15.158zM2.022 4a2.021 2.021 0 11-.002 4.043A2.021 2.021 0 012.021 4zm21.22 1.263a.758.758 0 01.103 1.509l-.103.007H8.084a.758.758 0 01-.103-1.509l.103-.007h15.158z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgListUl;
exports.default = _default;